<template>
  <div
    class="card"
    :data-min-from-last-mandatory="step.period || 0"
    :data-is-mandatory="step.is_mandatory || 0"
  >
    <header class="card-header">
      <div class="card-header-title">
        <span
          class="is-rounded tag"
          :class="[step.is_mandatory ? 'is-warning' : (step.show_details ? 'is-info' : 'is-gray')]"
        >
          Day <span class="total-from-start"><template v-if="step.sum_days">{{ step.sum_days }}</template><template v-else>0</template></span>
        </span>&nbsp;
        <span class="step-title">{{ step.name }}</span>
      </div>
    </header>
    <div class="card-content">
      <div class="content">
        <input
          type="hidden"
          name="is_mandatory[]"
          :value="step.is_mandatory || 0"
        >

        <div class="field">
          <label class="label">Notification type</label>
          <div class="control">
            <div class="select is-fullwidth">
              <div class="select-container">
                <select
                  v-if="step.possible_choices_list"
                  v-model="step.choice"
                  name="choice[]"
                >
                  <option
                    :value="undefined"
                    disabled
                    hidden
                  >
                    Choose a type ...
                  </option>
                  <option
                    v-for="(opt, idx) in step.possible_choices_list"
                    :key="idx"
                    :value="idx"
                  >
                    {{ opt.name }}
                  </option>
                </select>
                <select
                  v-else
                  v-model="step.choice"
                  name="choice[]"
                >
                  <option
                    :value="undefined"
                    disabled
                    hidden
                  >
                    Choose a type ...
                  </option>
                  <option
                    v-for="(opt, idx) in default_possible_choices_list"
                    :key="idx"
                    :value="idx"
                  >
                    {{ opt.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WorkflowStepComponent',
  props: {
    step: Object,
    index: { type: Number, default: 0 },
    default_possible_choices_list: Object,
    tpl_list: Object
  },
  methods: {

  }
};
</script>
<style scoped>
    .card-header-title .tag {
        margin-right: 1em;
    }

    .card-header-title .tag span:before {
        content: "\00a0";
    }

    .button + .button {
        margin-left: 1em;
    }
</style>
